<template>
<div>


    <spinner v-bind:spinner='spinner'></spinner>
    <div v-if="type == 'A'">
     <h4>LISTA ARTICOLI</h4>  
    <div  class="table-wrapper-scroll-y my-custom-scrollbar">
    <table class="table table-hover mb-0" id="table">
        
      <thead >
        <tr>
          <th>#</th>
          
          <th>ID</th>
          <th></th>
          <th></th>
       
          <th>CODICE ART.</th>
          <th>BRAND</th>
          <th>CATEGORIA</th>
          <th>COMPOSIZIONE</th>
          <th>REPARTO</th>
          <th class="text-right">Q.TA'</th>
          <th class="text-right">TOTALE</th>
          
        </tr>
      </thead>
      <tbody>
      <tr class="pointer" v-for="(product,index) in filteredProducts" :key="index">
        <td>{{index+1}}</td>
                
        <td>{{product.productId}}</td>
       
        <td><i @click="updateProduct(index)" style='color:#800080;' data-toggle="tooltip" title="modifica quantità" class="fa fa-edit" aria-hidden="true"></i></td>
              
        <td> <span :class="{dotRed:product.colorCount > 0}"></span></td>
        <td>{{product.sku}}</td>
        <td>{{product.brand.toUpperCase()}}</td>
        <td >{{product.category}}</td>
        <td >{{product.material}}</td>
        <td >{{product.department}}</td>
        <td class="text-right">{{product.qtyItem}}</td>
        <td class="text-right">{{product.totalItem.toLocaleString('de-DE',{ style: 'currency', currency: 'EUR' })}}</td>
        
      </tr>
      </tbody>
      <tfoot>
        <tr>
                            
          <th></th>
          
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th class="text-right">{{totalQty}}</th>
          <th class="text-right">{{totalVal.toLocaleString('de-DE',{ style: 'currency', currency: 'EUR' })}}</th>
                  
        </tr>
      </tfoot>  
    </table>
  </div>
  <label for="filter"><strong>Filtra</strong></label>
  <input class="form-control" type="text" name="query" v-model="filterKey">
  </div>
  <div v-else-if="type=='B'">

    <update-movement-product @close="type='A'" v-bind:movementId="movementId" v-bind:storeId="storeId" v-bind:productId="productId" v-bind:movementType="movementType" />
    
  </div>


  </div>
</template>

<script>

import api                     from '@/api'
import axios                   from 'axios'
import spinner                 from '@/components/common/Spinner.vue';

import updateMovementProduct     from '@/components/backOffice/UpdateMovementProduct.vue'

  export default {
     props : ['movementId','storeId','movementType'], 
     components : {spinner,updateMovementProduct},
    data () {
      return {
        type          : 'A',
        items         : [],
        productId     : 0,
        filterKey     : '',
        spinner       : false,
        pdf           : '',
        msg           : '',
        bt_spinner    : false,
        row           : 0
        
      }
    },
  
  
    computed: {
      
       filteredProducts : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
     
       
      totalQty ()  
      {
        var totale = 0

        
          this.filteredProducts.forEach(item => {
            totale = totale + Number(item.qtyItem)
          });
        
        return totale
      },
      totalVal ()
      {
        var totale = 0
        this.filteredProducts.forEach(item => {
            totale = totale + Number(item.totalItem)
          
          });
        
        return totale
      },
      
      
    },

    
    created () 
    {
     
      if(this.movementId>0)
      {
        //console.log('movementType1',this.movementType)
        this.getData()
      }
    },

    
    methods: 
    {
 
      updateProduct(index)
      {
        

        this.productId = this.filteredProducts[index]['productId']
        this.type = 'B'

      },
      printPDF()
      {
        
        this.bt_spinner = true
        this.msg = ''
        var url  = process.env.VUE_APP_ROOT_API + "api/document/create" 
        var data = {}
        data.items = this.filteredProducts
        
        var document = {type:this.shipping.typeId==1 ? 'Fattura' : 'DDT',data:this.shippingDate,number : this.shipping.number,supplier:this.supplier.List[0].supplier }
        var json  = Object.assign(data,document);

        axios({
        url     : url,
        method  : "post",
        data    : json,
        
      })
        .then(res => {
                 
         this.pdf   =  process.env.VUE_APP_ROOT_API + 'api/pdf/' +  res.data 
                  
         this.msg   = 'Il tuo documento è pronto.'

        })
        .catch(err => {})
        .finally(() => {

          this.bt_spinner = false
           
        });
      },
      async getData()
      {
        
        this.spinner = true                
        var data  = {'movementId' : this.movementId}
        
        var sp    = {'sp' : 'spMovementProducts'}
        var json  = Object.assign(data, sp);

        await api.post(json).then(res => {
          
        

          if(res.status==200)
            {
              this.items = res.data.recordsets[0] 
              //console.log(res.data.recordsets[1] )
            }
           else if(res.status==500)
           {
                console.log(res.data)

                
                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });

  
      },
      
      
      
      

      deleteProduct (id) 
      {
        console.log(id)
      
      }
      

    }
  }
</script>
<style scoped>
  
.pointer:hover
{
  background-color : blue;
  color            : white;
  cursor           : pointer;
}
 
.my-custom-scrollbar 
{
  position  : relative;
  height    : 500px;
  overflow  : auto;
}
.table-wrapper-scroll-y 
{
  display   : block;
}

p,h4 
{
  font-family : 'Roboto Condensed';
  font-size   : 20px;
}

.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.table tfoot tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 18px;
    background   : navajowhite;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;

 }

.table th:first-child
{
  border-radius : 0 0 0 8px;
}
.table th:last-child
{
  border-radius : 0 8px 0 0;  
}
.dotGreen
{
  height: 15px;
  width: 15px;
  
  border-radius: 50%;
  display: inline-block;
  background-color: green;
}
.dotRed
{
  height: 15px;
  width: 15px;
  
  border-radius: 50%;
  display: inline-block;
  background-color: red;
}
</style>
